import React from 'react';
import { useAbility } from 'shared/access';
import { Viewer } from 'shared/ui/Viewer';
import { OVERLAYS, isOverlayAllowed, useActiveOverlay } from 'app/registry/overlayRegistry';
import { useLayout } from './LayoutProvider';

/** Renders every self-hosted overlay (save, load, export, reprice) always —
 *  each is a no-op while its own flag is false — plus whichever plain view
 *  (Rack View, System Slide) the layout service currently has open, wrapped
 *  in the one shared Viewer. */
export function Overlays() {
  const active = useActiveOverlay();
  const { closeOverlay } = useLayout();
  const ability = useAbility();
  const selfHosted = OVERLAYS.filter((o) => o.selfHosted && isOverlayAllowed(o, ability));
  return (
    <>
      {selfHosted.map((o) => <o.Component key={o.id} />)}
      {active && !active.selfHosted && (
        <Viewer open onClose={closeOverlay} title={active.title}>
          <active.Component />
        </Viewer>
      )}
    </>
  );
}
